export default "__VITE_ASSET__cdeaf1df__"